
export default emits => {
  return editor => {
    editor.ui.registry.addButton('customImage', {
      icon: 'image',
      tooltip: '插入图片',
      onAction: () => {
        // 触发父组件打开自定义弹窗
        emits('openFilePicker', {
          onConfirm: ({ filePath }) => {
            editor.insertContent(`<img src="${filePath}" style="max-width: 100%;">`)
          },
        })
      },
    })

    return {
      getMetadata: () => ({
        name: 'Custom Image Plugin',
        url: 'https://example.com',
      }),
    }
  }
}
